import { useEffect, useState } from 'react'
import { supabase } from '../../../lib/supabase'
import { CategoryForm } from './CategoryForm'
import { CategoryItem } from './CategoryItem'

export interface Category {
  id: number
  parent_id: number | null
  level: number
  name: string
  description: string | null
  help_text: string | null
  img: string | null
  orderlevel: number
  show_tematic_data: boolean
  show_species_data: boolean  
  created_at: string
  children?: Category[]
}

export function CategoryList() {
  const [categories, setCategories] = useState<Category[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  const [showForm, setShowForm] = useState(false)
  const [editingId, setEditingId] = useState<number | null>(null)
  const [parentId, setParentId] = useState<number | null>(null)

  useEffect(() => {
    loadCategories()
  }, [])

  const buildTree = (items: Category[]) => {
    const map = new Map<number, Category>()
    const roots: Category[] = []

    items.forEach(i => map.set(i.id, { ...i, children: [] }))
    map.forEach(cat => {
      if (cat.parent_id) {
        map.get(cat.parent_id)?.children?.push(cat)
      } else {
        roots.push(cat)
      }
    })

    return roots
  }

  const loadCategories = async () => {
    try {
      setLoading(true)
      const { data, error } = await supabase
        .from('categories')
        .select('*')
        .order('orderlevel')

      if (error) throw error
      setCategories(buildTree(data as Category[]))
    } catch (e) {
      console.error(e)
      setError('Error cargando categorías')
    } finally {
      setLoading(false)
    }
  }

  const handleDelete = async (id: number) => {
    if (!confirm('¿Eliminar esta categoría?')) return
    await supabase.from('categories').delete().eq('id', id)
    loadCategories()
  }

  if (loading) return <p>Cargando categorías...</p>
  if (error) return <p className="text-red-600">{error}</p>

  return (
    <div className="max-w-6xl mx-auto space-y-6">
      <div className="flex justify-between items-center">
        <h1 className="text-2xl font-bold">Categorías</h1>
          <button className="px-6 py-3 bg-green-600 text-white rounded-lg font-medium hover:bg-green-700 flex items-center gap-2"
            onClick={() => {
                        setEditingId(null)
                        setParentId(null)
                        setShowForm(true)
                      }}
          >
            <span className="text-xl">+</span>
            Nueva categoría
          </button>
      </div>

      <ul className="space-y-4">
        {categories.map(cat => (
          <CategoryItem
            key={cat.id}
            category={cat}
            onEdit={(id) => {
              setEditingId(id)
              setParentId(null)
              setShowForm(true)
            }}
            onAddChild={(pid) => {
              setParentId(pid)
              setEditingId(null)
              setShowForm(true)
            }}
            onDelete={handleDelete}
          />
        ))}
      </ul>

      {showForm && (
        <CategoryForm
          categoryId={editingId}
          parentId={parentId}
          onClose={() => setShowForm(false)}
          onSuccess={() => {
            setShowForm(false)
            loadCategories()
          }}
        />
      )}
    </div>
  )
}